export default __webpack_public_path__ + "static/media/attract-loop-vertical.063fb6d8.mp4";